import React from 'react';

const EffectsLayer = ({ flashType, flashOn, confetti, ripple, feedback, feedbackVisible }) => (
  <>
    <div className="toast-layer" id="toastLayer">
      <div className={`flash ${flashType} ${flashOn ? 'on' : ''}`} id="flashLayer" />
      {confetti.map((piece) => (
        <div
          key={piece.id}
          className="confetti"
          style={{
            left: piece.left,
            top: piece.top,
            background: piece.color,
            '--dx': piece.dx,
            '--dy': piece.dy,
            '--rot': piece.rot,
          }}
        />
      ))}
      {ripple && <div className="ripple" style={{ left: ripple.left, top: ripple.top }} />}
    </div>

    <div
      id="feedback"
      className="feedback"
      style={{
        opacity: feedbackVisible ? 1 : 0,
        transform: feedbackVisible ? 'translate(-50%, -24px)' : 'translate(-50%, 8px)',
      }}
    >
      {feedback}
    </div>
  </>
);

export default EffectsLayer;
